import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';

import {buildArray} from 'shared/web';

interface VehicleActivityPanelProps {
  vehicleId: string;
}

export function VehicleActivityPanel(props: VehicleActivityPanelProps) {
  const actions = buildArray<ActivitySidebarAction>().whenFeatureEnabled(
    featureFlags.CUSTOM_NOTICES,
    buildCustomNoticesSidebarAction({
      resourceId: EntityResourceIds.vehicle,
      recordId: props.vehicleId,
    })
  );

  return <ActivitySidebarV2 actions={actions} />;
}
